const checkEmptyString = (str) => {
  if (!str || !str.replace(/[!@#$%¨&()_+=~^<>*|"]/g, '').trim()) {
    return true;
  }

  return false;
}

export default checkEmptyString;